import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7007Model } from '../kymw7007.model';
import { RequestInfo } from '../vo/request-info.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

// レスポンス構造
type GetRequestListInfoResponse = {
  OrderCode: string;
  MediumType: string;
  MediumTypeName: string;
  BuyerRequestId: string;
  RequestStatus: number;
  RequestStatusName: string;
  RequestType: number;
  RequestTypeName: string;
  FeatureCode: string;
  FeatureName: string;
  ClassCode: string;
  ClassCodeName: string;
  MiddleClassCode: string;
  MiddleClassCodeName: string;
  PCode: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  TagName: string;
  ThisTimeSupplyPrice: number;
  PricePattern: number;
  PricePatternName: string;
  PlanNumAiPrediction: number;
  PlanNum: number;
  PlanSupplyBudget: number;
  ThisTimeCostPrice: number;
  Gpr: number;
}[];

/**
 * 依頼一覧情報取得サービス
 * @export GetRequestListInfoService
 * @class GetRequestListInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetRequestListInfoService extends PlessJsonResponderSub<GetRequestListInfoResponse> {
  model: KYMW7007Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetRequestListInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetRequestListInfoService
   */
  execute(model: KYMW7007Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getRequestListInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetRequestListInfoService
   */
  success(data: GetRequestListInfoResponse) {
    this.model.requestInfoList = data.map(_ => new RequestInfo(
      _.OrderCode,
      _.MediumType,
      _.MediumTypeName,
      _.BuyerRequestId,
      _.RequestStatus,
      _.RequestStatusName,
      _.RequestType,
      _.RequestTypeName,
      _.FeatureCode,
      _.FeatureName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.FeatureCode, _.FeatureName),
      _.ClassCode,
      _.ClassCodeName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.ClassCode, _.ClassCodeName),
      _.MiddleClassCode,
      _.MiddleClassCodeName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.MiddleClassCode, _.MiddleClassCodeName),
      _.PCode,
      _.GuideGoodsName,
      _.GuideStandardName,
      _.TagName,
      _.ThisTimeSupplyPrice,
      _.PricePattern,
      _.PricePatternName,
      _.PlanNum,
      _.PlanSupplyBudget,
      this.model.setDispPlanSupplyBudget(_.PlanSupplyBudget),
      _.ThisTimeCostPrice,
      _.Gpr
    ));
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
